import * as React from "react";
import {
  Box,
  ImageList,
  ImageListItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Container from "@mui/material/Container";

const galleryImages = [
  "circle1.jpg",
  "circle2.jpg",
  "circle3.jpg",
  "circle4.jpg",
  "circle5.jpg",
  "circle6.jpg",
  "circle7.jpg",
];

const ImageListItemStyled = ({ image }) => {
  const imageFile = require(`../../images/assets/${image}`);

  return (
    <ImageListItem>
      <img
        src={`${imageFile}?w=248&fit=crop&auto=format`}
        srcSet={`${imageFile}?w=248&fit=crop&auto=format&dpr=2 2x`}
        alt="Gallery item"
        loading="lazy"
      />
    </ImageListItem>
  );
};

function FestivalHub() {
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            CACTUS SQUARE x FESTIVAL HUB x WRISTBAND COLLECTION
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Location
          </Typography>
          <Typography className="text">
            Circle Square, Symphony Park, Oxford Rd, Manchester M1 7FS.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Wristband Collection
          </Typography>
          <Typography className="text">
            #2 Circle Square Reception. Open 10am-9pm.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Official Festival Merch
          </Typography>
          <Typography className="text">
            Circle Square green’s gazebo village
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Food, Ice Cream, Coffee & Bar
          </Typography>
          <Typography className="text">
            MPF x Bellfield Brewery Bar, Hello Oriental, Poutine Punks, Little
            Boa Boys, Federal, Seitan’s Kebabs, Shoegaze Café, Rizzo’s.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Workshops, Wellbeing & Shopping
          </Typography>
          <Typography className="text">Psych Yoga 11am-1pm.</Typography>
          <Typography className="text">
            Workshop: Postcards from Manchester Psych Fest.
            1pm-4pm.
          </Typography>
          <Typography className="text">
            Official Festival Merch. Exhibitions. Visuals. Bionic Seven Pop Up
            Vintage. Exhibitions & Murals
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Contact
          </Typography>
          <Typography className="text">info@manchesterpsychfest.com</Typography>
        </div>
        <Box sx={{ flexGrow: 1, display: { xs: "flex" } }}>
          <ImageList variant="masonry" cols={matches ? 3 : 1} gap={8}>
            {galleryImages.map((image, index) => (
              <ImageListItemStyled key={index} image={image} />
            ))}
          </ImageList>
        </Box>
      </div>
    </Container>
  );
}
export default FestivalHub;
